import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FlatButtonComponent } from '@shared/button/flat-button/flat-button.component';
import DATA_QA from '@automation/data-qa.json';

@Component({
    template: `<div class="p-5">
        <p class="text-lg mb-3">
            Unassign {{ data.discrepancyCount }} {{ discrepancyNoun }}
        </p>
        <p>
            You will be unassigning {{ data.discrepancyCount }}
            {{ discrepancyNounLower }}.
        </p>
        <div class="flex justify-end gap-8 mt-5">
            <app-flat-button
                (clicked)="cancel()"
                [dataQa]="dataQa.unassignDiscrepancyDialogCancel">
                Cancel
            </app-flat-button>
            <app-flat-button
                variant="cta"
                (clicked)="unassign()"
                [dataQa]="dataQa.unassignDiscrepancyDialogUnassign">
                Unassign
            </app-flat-button>
        </div>
    </div>`,
    imports: [FlatButtonComponent],
})
export class UnassignConfirmDialogComponent {
    readonly dataQa = DATA_QA;
    readonly data: UnassignConfirmDialogData = inject(MAT_DIALOG_DATA);
    private readonly dialogRef = inject(
        MatDialogRef<UnassignConfirmDialogComponent>,
    );

    get discrepancyNoun() {
        return this.data.discrepancyCount === 1
            ? 'Discrepancy'
            : 'Discrepancies';
    }

    get discrepancyNounLower() {
        return this.discrepancyNoun.toLowerCase();
    }

    protected cancel() {
        this.dialogRef.close();
    }

    protected unassign() {
        this.dialogRef.close({ unassign: true });
    }
}

export interface UnassignConfirmDialogData {
    discrepancyCount: number;
}
